export const DELETE_TAKEAWAY_REQUEST = " DELETE_TAKEAWAY_REQUEST";
export const DELETE_TAKEAWAY_SUCCESS = " DELETE_TAKEAWAY_SUCCESS";
export const DELETE_TAKEAWAY_FAILURE = " DELETE_TAKEAWAY_FAILURE";
